import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import {
  getSuperadminDashboard,
  getSupportOverview,
  getSystemHealthGraph,
  getSystemHealthOverview,
  getSystemMemoryUtilisation,
  getSystemMemoryUtilisationGraph,
} from "../../redux/actions/dashboard";
import { useDispatch, useSelector } from "react-redux";
import SuperAdminTickets from "../../assets/icons/SuperAdminTickets.png";
import PticketsSA from "../../assets/icons/PticketsSA.png";
import ResponseTimeSA from "../../assets/icons/ResponseTimeSA.png";
import SystemUptimeSA from "../../assets/icons/SystemuUptimeSA.png";
import MemoryUtiliseSA from "../../assets/icons/MemoryUtiliseSA.png";
import ActiveUsersSA from "../../assets/icons/ActiveUsersSA.png";
import BlockedIPsSA from "../../assets/icons/BlockedIPsSA.png";
import ApiSA from "../../assets/icons/ApiSA.png";
import { useNavigate } from "react-router-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  BarChart,
  Bar,
  ReferenceLine,
} from "recharts";

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  value,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) / 2;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={14}
      fontWeight="600"
    >
      {value}
    </text>
  );
};

const pieColors = ["#f44336", "#fb8c00", "#757575"];

const MonitoringDashboard = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSuperadminDashboard(props.filter));
    dispatch(getSupportOverview(props.filter));
    dispatch(getSystemHealthGraph(props.filter));
    dispatch(getSystemHealthOverview(props.filter));
    dispatch(getSystemMemoryUtilisationGraph(props.filter));
  }, [dispatch, props.filter]);

  const cpuGraphData = useSelector(
    (state) =>
      state.dashboard.getSystemHealthDashboardGraph?.data?.cpu_graph || []
  );

  const cpuGraphReduxState = useSelector(
    (state) => state.dashboard.getSystemMemoryUtilisationGraph
  );

  const dashboardState = useSelector((state) => state.dashboard);

  const cpuUsageData = cpuGraphData.map((item) => ({
    time: String(item.duration),
    usage: item.cpu_utilisation,
  }));

  const statisticsData = useSelector(
    (state) => state.dashboard.getAdminDashboard.data
  );

  const statisticsData1 = useSelector(
    (state) => state.dashboard.getAdminMonitoringDashboard.data
  );

  const navigate = useNavigate();

  const handleCardClick = (type) => {
    if (type === "Open Tickets") {
      navigate("/super-admin-tickets", {
        state: { fromDashboard: true },
      });
    } else if (type === "Active Users") {
      navigate("/active-users", {
        state: { fromDashboard: true },
      });
    } else if (type === "P1 Tickets") {
      navigate("/super-admin-tickets", {
        state: {
          severity: "high",
          fromCard: "P1  Tickets",
          fromDashboard: true,
        },
      });
    } else if (type === "P2 Tickets") {
      navigate("/super-admin-tickets", {
        state: {
          severity: "medium",
          fromCard: "P2  Tickets",
          fromDashboard: true,
        },
      });
    } else if (type === "P3 Tickets") {
      navigate("/super-admin-tickets", {
        state: {
          severity: "low",
          fromCard: "P3  Tickets",
          fromDashboard: true,
        },
      });
    } else if (type === "Response Time") {
      navigate("/response_time", {
        state: { fromDashboard: true },
      });
    } else if (type === "System Uptime") {
      navigate("/system_uptime", {
        state: { fromDashboard: true },
      });
    } else if (type === "API Requests") {
      navigate("/api_requests", {
        state: { fromDashboard: true },
      });
    } else if (type === "Memory Utilization") {
      navigate("/system-memory-utilisation-table", {
        state: { fromDashboard: true },
      });
    } else if (type === "Memory Utilization Graph") {
      navigate("/system-memory-utilisation-graphtable", {
        state: { fromDashboard: true },
      });
    }
  };

  const systemHealthGraph = useSelector(
    (state) => state.dashboard.getAdminGraphDashboard
  );
  const systemUptimeChartData =
    systemHealthGraph?.data?.uptime_data?.map((d) => ({
      date: d.duration,
      uptime: d.uptime,
    })) || [];

  const errorRateData =
    systemHealthGraph?.data?.error_data?.map((d) => ({
      date: d.duration,
      error404: d.error_404,
      error500: d.error_500,
      error403: d.error_403,
    })) || [];

  const openTicketPieData = [
    {
      name: "P1 (Priority 1)",
      value: systemHealthGraph?.data?.ticket_priority_data?.p1 || 0,
    },
    {
      name: "P2 (Priority 2)",
      value: systemHealthGraph?.data?.ticket_priority_data?.p2 || 0,
    },
    {
      name: "P3 (Priority 3)",
      value: systemHealthGraph?.data?.ticket_priority_data?.p3 || 0,
    },
  ];

  const systemHealthMetrics = useSelector(
    (state) => state.dashboard.getSystemHealthDashboard.data
  );

  const systemHealthData = [
    {
      heading: "System Uptime",
      value: `${systemHealthMetrics?.system_uptime?.toFixed(2) || 0}%`,
      icon: SystemUptimeSA,
      color: "#E0F2F1",
      border: "#B71C1C",
      textColor: " #000",
    },
    {
      heading: "Response Time",
      value: `${Math.round(systemHealthMetrics?.response_time || 0)}ms`,
      icon: ResponseTimeSA,
      color: "#EDE7F6",
      border: "#B71C1C",
      textColor: "#000",
    },
    {
      heading: "Memory Utilization",
      value: `${systemHealthMetrics?.memory_utilization || "NA"}% used`,
      icon: MemoryUtiliseSA,
      color: "rgb(250, 246, 240)",
      border: "#B71C1C",
      textColor: "rgb(227, 151, 21)",
    },
    {
      heading: "API Requests",
      value: `${
        systemHealthMetrics?.api_requests?.toLocaleString() || 0
      } requests`,
      icon: ApiSA,
      color: "#E3F2FD",
      border: "#B71C1C",
      textColor: "rgb(63, 113, 150)",
    },
    {
      heading: "Blocked IPs",
      value: `${systemHealthMetrics?.blocked_ips || "NA"} `,
      icon: BlockedIPsSA,
      color: "rgb(196, 196, 196)",
      border: "#B71C1C",
      textColor: "rgb(94, 33, 33)",
    },
  ];

  const supportOverviewData = [
    {
      heading: "Open Tickets",
      value: statisticsData1?.open_tickets || "0",
      icon: SuperAdminTickets,
      border: "#2E7D32",
      color: "#2E7D32",
    },
    {
      heading: "P1 Tickets",
      value: statisticsData1?.p1_tickets || "0",
      icon: PticketsSA,
      border: "#C62828",
      color: "#C62828",
    },
    {
      heading: "P2 Tickets",
      value: statisticsData1?.p2_tickets || "0",
      icon: PticketsSA,
      border: "#EF6C00",
      color: "#EF6C00",
    },
    {
      heading: "P3 Tickets",
      value: statisticsData1?.p3_tickets || "0",
      icon: PticketsSA,
      border: "#757575",
      color: "#757575",
    },
    {
      heading: "Active Users",
      value: statisticsData1?.active_users || "0",
      icon: ActiveUsersSA,
      border: "#1565C0",
      color: "#1565C0",
    },
  ];

  const renderCardGroup = (data) => (
    <Grid container spacing={3} justifyContent="center">
      {data.map((item, index) => {
        let borderColor = "#333";
        let bgColor = "#fff";
        let valueColor = "#333";

        switch (item.label) {
          case "System uptime":
          case "Open Tickets":
            borderColor = "#2e7d32";
            bgColor = "rgba(46, 125, 50, 0.08)";
            valueColor = "#2e7d32";
            break;
          case "Response Time":
            borderColor = "#8e24aa";
            bgColor = "rgba(142, 36, 170, 0.08)";
            valueColor = "#8e24aa";
            break;
          case "Memory Utilization":
          case "P2 tickets":
            borderColor = "#fb8c00";
            bgColor = "rgba(251, 140, 0, 0.08)";
            valueColor = "#fb8c00";
            break;
          case "API Requests":
          case "Active Users":
            borderColor = "#1976d2";
            bgColor = "rgba(25, 118, 210, 0.08)";
            valueColor = "#1976d2";
            break;
          case "Blocked IP":
          case "P1 tickets":
            borderColor = "#c62828";
            bgColor = " #757575";
            valueColor = "#c62828";
            break;
          case "P3 tickets":
            borderColor = "#757575";
            bgColor = "rgba(117, 117, 117, 0.08)";
            valueColor = "#424242";
            break;
          default:
            break;
        }

        const [mainVal, ...unit] = item.value.split(" ");

        return (
          <Grid item xs={12} sm={6} md={2.4} key={index}>
            <Card
              sx={{
                border: `2px solid ${borderColor}`,
                borderRadius: "12px",
                backgroundColor: bgColor,
                height: "100%",
                textAlign: "center",
              }}
            >
              <CardContent>
                <Box mb={1}>{item.icon}</Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="baseline"
                  mb={0.5}
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ color: valueColor }}
                  >
                    {mainVal}
                  </Typography>
                  {unit.length > 0 && (
                    <Typography
                      variant="h6"
                      sx={{ color: valueColor, ml: 0.3, fontWeight: 500 }}
                    >
                      {unit.join(" ")}
                    </Typography>
                  )}
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#333",
                    fontWeight: 400,
                  }}
                >
                  {item.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );

  return (
    <DashboardLayout classes={undefined}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* System Health Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 4 }}>
          <Box sx={{ position: "relative", mb: 3 }}>
            <Typography variant="h6" fontWeight={600} align="center">
              System Health Overview
            </Typography>
            <Typography
              variant="body2"
              fontWeight={500}
              sx={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              In last 24 Hours
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {systemHealthData.map((item, i) => {
              const [mainVal, ...unit] = item.value.toString().split(" ");

              return (
                <Grid item xs={12} sm={6} md={2.4} key={i}>
                  <Box textAlign="center" mb={1} fontSize={15} fontWeight={600}>
                    {item.heading}
                  </Box>
                  <Card
                    sx={{
                      border: `2px solid ${item.border}`,
                      background: item.color,
                      borderRadius: 2,
                    }}
                    onClick={() => handleCardClick(item.heading)}
                  >
                    <CardContent>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <img
                          src={item.icon}
                          alt={item.heading}
                          style={{ width: 30, marginBottom: 8 }}
                        />

                        <Box
                          display="flex"
                          alignItems="baseline"
                          justifyContent="center"
                        >
                          <Typography
                            variant="h4"
                            fontWeight={600}
                            color={item.textColor}
                          >
                            {mainVal}
                          </Typography>
                          {unit.length > 0 && (
                            <Typography
                              variant="h5"
                              sx={{ ml: 0.5, fontWeight: 400 }}
                              color={item.textColor}
                            >
                              {unit.join(" ")}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ p: 3 }}>
          <Typography variant="h6" align="center" mb={3} fontWeight={600}>
            Support Overview
          </Typography>
          <Grid container spacing={2}>
            {supportOverviewData.map((item, i) => (
              <Grid item xs={12} sm={6} md={2.4} key={i}>
                <Card
                  sx={{
                    border: `2px solid ${item.border}`,
                    borderRadius: 2,
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "120px",
                  }}
                  onClick={() => handleCardClick(item.heading)}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      p: 2,
                      "&:last-child": { pb: 2 },
                    }}
                  >
                    <Box display="flex" alignItems="center" mb={0.5}>
                      <img
                        src={item.icon}
                        alt={item.heading}
                        style={{ width: 30, marginRight: 8 }}
                      />
                      <Typography
                        variant="h5"
                        fontWeight={600}
                        color={item.color}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      align="center"
                      sx={{ color: item.color }}
                    >
                      {item.heading}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>

        <Grid container spacing={3} mt={3}>
          <Grid item xs={12} md={12}>
            <Paper
              elevation={3}
              sx={{ p: 3, height: "100%", cursor: "pointer" }}
              onClick={() => navigate("/system_uptime")}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ fontWeight: 400, marginBottom: 2 }}
              >
                System Uptime
              </Typography>
              <ResponsiveContainer width="100%" height={350}>
                <LineChart
                  data={systemUptimeChartData}
                  margin={{ left: 30, right: 10, top: 20, bottom: 20 }}
                >
                  <XAxis
                    dataKey="date"
                    label={{
                      value: "Duration",
                      position: "insideBottom",
                      offset: -9,
                      style: { textAnchor: "middle" },
                    }}
                    tick={{ fontSize: 12 }}
                    tickMargin={8}
                    padding={{ left: 30, right: 0 }}
                    tickFormatter={(date) => {
                      return date;
                    }}
                  />
                  <YAxis
                    type="number"
                    domain={["auto", "auto"]}
                    tick={{ fontSize: 12 }}
                    label={{
                      value: "Uptime (%)",
                      angle: -90,
                      position: "insideLeft",
                      offset: 10,
                    }}
                  />

                  <Tooltip />

                  <Legend
                    verticalAlign="bottom"
                    align="right"
                    content={() => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: 24,
                              height: 8,
                              backgroundColor: "#2e7d32",
                              marginRight: 8,
                            }}
                          />
                          <span
                            style={{
                              color: "rgb(56, 56, 56)",
                              fontWeight: 400,
                            }}
                          >
                            System Up time
                          </span>
                        </div>
                      </div>
                    )}
                  />

                  <Line
                    type="monotone"
                    dataKey="uptime"
                    stroke="#2e7d32"
                    strokeWidth={2}
                    dot={{
                      fill: "#000",
                      stroke: "#2e7d32",
                      strokeWidth: 2,
                      r: 4,
                    }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>

          <Grid item xs={12} md={12}>
            <Paper
              elevation={3}
              sx={{ p: 3, height: "100%", cursor: "pointer" }}
              onClick={() => navigate("/error_log")}
            >
              <Typography variant="h6" fontWeight="400" mb={2}>
                Error Rate Trends
              </Typography>

              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={errorRateData}
                  margin={{ top: 20, right: 30, left: 30, bottom: 20 }}
                >
                  <XAxis
                    dataKey="date"
                    label={{
                      value: "Duration",
                      position: "insideBottom",
                      offset: -5,
                    }}
                    tick={{ fontSize: 12 }}
                    interval={0}
                  />
                  <YAxis
                    label={{
                      value: "Error Rate",
                      angle: -90,
                      position: "insideLeft",
                      offset: 10,
                    }}
                    tick={{ fontSize: 12 }}
                  />
                  <Tooltip />

                  <Bar dataKey="error404" fill="#a93226" />
                  <Bar dataKey="error500" fill="#e67e22" />
                  <Bar dataKey="error403" fill="#641e16" />
                </BarChart>
              </ResponsiveContainer>

              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                mt={2}
              >
                <Box display="flex" alignItems="center" mb={1} sx={{ mr: 17 }}>
                  <Box
                    sx={{
                      width: 20,
                      height: 8,
                      bgcolor: "#a93226",
                      flexShrink: 0,
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2">404 Not Found</Typography>
                </Box>

                <Box display="flex" alignItems="center" mb={1}>
                  <Box
                    sx={{
                      width: 20,
                      height: 8,
                      bgcolor: "#e67e22",
                      flexShrink: 0,
                      mr: 0,
                    }}
                  />
                  <Typography variant="body2" sx={{ marginLeft: 1 }}>
                    500 Internal Server Errors
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" mb={1} sx={{ mr: 17 }}>
                  <Box
                    sx={{
                      width: 20,
                      height: 8,
                      bgcolor: "#641e16",
                      flexShrink: 0,
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2" sx={{ marginLeft: 1 }}>
                    403 Forbidden
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={12}>
            <Paper
              elevation={3}
              sx={{ p: 3, height: "100%", cursor: "pointer" }}
              onClick={() => navigate("/system-memory-utilisation-graphtable")}
            >
              <Typography variant="h6" fontWeight="400" mb={2}>
                CPU Usage
              </Typography>
              <ResponsiveContainer width="100%" height={350}>
                <AreaChart
                  data={cpuUsageData}
                  margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
                >
                  <XAxis
                    dataKey="time"
                    type="number"
                    domain={[1, 24]}
                    tick={{ fontSize: 12 }}
                    tickMargin={10}
                    ticks={Array.from({ length: 24 }, (_, i) => i + 1)}
                    label={{
                      value: "Duration (hours)",
                      position: "insideBottom",
                      offset: -12,
                    }}
                    tickFormatter={(val) => val.toString().padStart(2, "0")}
                  />

                  <YAxis
                    dataKey="usage"
                    domain={[0, "auto"]}
                    tick={{ fontSize: 12 }}
                    label={{
                      value: "CPU Utilization (%)",
                      angle: -90,
                      position: "insideLeft",
                      offset: 10,
                    }}
                  />

                  <Tooltip />

                  <Legend
                    verticalAlign="bottom"
                    align="right"
                    content={() => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          paddingRight: 40,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: 24,
                              height: 8,
                              backgroundColor: "rgb(0, 218, 242)",
                              marginRight: 8,
                            }}
                          />
                          <span
                            style={{
                              color: "rgb(56, 56, 56)",
                              fontWeight: 400,
                            }}
                          >
                            CPU Usage
                          </span>
                        </div>
                      </div>
                    )}
                  />

                  <Area
                    type="linear"
                    dataKey="usage"
                    stroke="#00e5ff"
                    fill="rgb(0, 218, 242)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 3, height: "100%" }}>
              <Typography variant="h6" fontWeight="400" mb={2} align="center">
                Open Tickets by Priority
              </Typography>
              <ResponsiveContainer width="100%" height={350}>
                <PieChart
                  onClick={() =>
                    navigate("/super-admin-tickets", {
                      state: { fromDashboard: true },
                    })
                  }
                >
                  <Pie
                    data={openTicketPieData}
                    cx="30%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={95}
                    paddingAngle={0}
                    dataKey="value"
                    label={renderCustomizedLabel}
                    labelLine={false}
                    isAnimationActive={false}
                    activeIndex={-1}
                    activeShape={() => null}
                    onMouseEnter={() => {}}
                  >
                    {openTicketPieData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={pieColors[index % pieColors.length]}
                        stroke="none"
                      />
                    ))}
                  </Pie>

                  <Legend
                    layout="vertical"
                    align="right"
                    verticalAlign="middle"
                    iconType="square"
                    formatter={(value) => (
                      <span style={{ fontSize: 14, color: "#000" }}>
                        {value}
                      </span>
                    )}
                  />
                </PieChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </DashboardLayout>
  );
};

export default MonitoringDashboard;
